<template>
  <b-container id="DashboardAdminTop">
    <b-row class="mb-4">
      <b-col xl="4" lg="12" md="12" sm="12" class="dashboardTitle align-items-center">
        <h1>
          {{ currentUser.organization.name }} Dashboard
        </h1>
      </b-col>
      <b-col xl="8" lg="12" md="12" sm="12" :class="['top-buttons', 'align-items-center', currentUser.admin && false ? 'justify-content-between': 'justify-content-end']">
        <b-row>
          <b-col xl="4" lg="4" md="4" sm="4" xs="12">
            <TMGeneralButton
              text="CREATE NEW SURVEY"
              className="snow new-survey"
              route="AdminSurveys"
              v-if="currentUser.admin"
            />
          </b-col>
          <b-col xl="4" lg="4" md="4" sm="4" xs="12">
            <TMGeneralButton
              text="ADD GROUP MANAGER"
              route="NewGroupManager"
              className="yellow add-manager"
              v-if="currentUser.admin"
            />
          </b-col>
          <b-col xl="4" lg="4" md="4" sm="4" xs="12">
            <TMGeneralButton
              text="CREATE GROUP"
              className="yellow new-group"
              route="NewGroup"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="4" lg="12" md="12" sm="12" order-xl="1" order-lg="1" order-md="1" order-sm="1" id="dashboard_info__wrapper">
        <b-row >
          <b-col xl="12" lg="6" md="6" sm="6">
            <div id="dashboard_info">
              <h4 v-if="empty">Create Groups to start seeing feedback</h4>
              <h4 v-if="!empty">View group scores and progress over time</h4>

              <b-row class="mb-3" v-if="!empty">
                <b-col :class="empty ? 'message empty' : ''">
                  <b-dropdown
                    id="lastestPresentations"
                    text="List of Groups"
                    variant="outline-secondary"
                    no-flip
                  >
                    <b-dropdown-header id="lastestPresentationHeader">
                      Select up to 6 groups to compare
                    </b-dropdown-header>
                    <b-dropdown-form class="dropdown-content">
                      <b-form-checkbox
                        v-for="(group, idx) in groups"
                        v-bind:key="idx"
                        :checked="setChecked(idx)"
                        :disabled="setDisabled(idx)"
                        @input.native="selectGroup($event, idx)"
                        stacked
                      >
                        <div class="presentationName">{{ group.name }}</div>
                      </b-form-checkbox>
                      <div class="dropdown-footer">
                          <a :class="['clear-btn', { disabled: selection.length === 0}]" @click="clearSelection">Clear</a>
                          <TMGeneralButton
                            :class="['save-btn', { disabled: selection.length === 0}]"
                            text="SAVE"
                            @click.native="saveSelection()"
                            className="yellow"
                          />
                      </div>
                    </b-dropdown-form>
                  </b-dropdown>
                </b-col>
              </b-row>
              <FeedbackScore
                  text_3="The percentage on the upper right of each chart represents the average score for this key skill for all presentations in all groups."
                  text_4="This was calculated by adding the scores for all the groups for this skill and dividing it by the total number of groups."
                  text_6="Each vertical bar represents one group."
                  text_5="The percentage on top of the bar is the group's average score for that key skill. This average was calculated by adding all the scores of the group members in that skill and dividing it by the total number of members."
                />
            </div>
          </b-col>
          <b-col class="extra-info" xl="12" lg="6" md="6" sm="6">
            <div class="valid">
              {{ currentUser.organization.users }} used |
              {{ currentUser.organization.presenter_maximum }} available
            </div>
            <b-progress
              :value="currentUser.organization.users"
              :max="currentUser.organization.presenter_maximum"
            ></b-progress>
            <div class="valid">
              Valid until {{ format_date(currentUser.expiration_date) }} <br />
              <span class="contact-text">Contact us to upgrade your plan</span>
              <span class="contact-email">
                <font-awesome-icon :icon="['far', 'envelope']" /> contact@torchmetrics.com
              </span>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col xl="8" sm="12" order-xl="2" order-lg="2" order-md="2" order-sm="2" >
        <b-row>
          <b-col xl="6" lg="6" md="6" xm="12">
            <div class="box">
              <BarDashboard
                icon="/img/dashboardTop/Component 242 – 12@2x.png"
                iconBig="/img/dashboardTop/Component 242 – 12@2x.png"
                title="Content"
                subtitle="Audience-Oriented"
                :feedback="getMessage('Content')"
                :percentage="promMetrics('Content')"
                :labels="setCharts('Content')"
                :verification="getRespondents()"
              />
            </div>
          </b-col>
          <b-col xl="6" lg="6" md="6" xm="12">
            <div class="box">
              <BarDashboard
                icon="/img/dashboardTop/Component 239 – 12@2x.png"
                iconBig="/img/dashboardTop/Component 239 – 12@2x.png"
                title="Visuals"
                subtitle="Message-Focused"
                :feedback="getMessage('Visuals')"
                :percentage="promMetrics('Visuals')"
                :labels="setCharts('Visuals')"
                :verification="getRespondents()"
              />
            </div>
          </b-col>
          <b-col xl="6" lg="6" md="6" xm="12">
            <div class="box">
              <BarDashboard
                icon="/img/dashboardTop/Component 242 – 29@2x.png"
                iconBig="/img/dashboardTop/visuals_icon.png"
                title="Delivery"
                subtitle="Persuasive and Confident"
                :feedback="getMessage('Delivery')"
                :percentage="promMetrics('Delivery')"
                :labels="setCharts('Delivery')"
                :verification="getRespondents()"
              />
            </div>
          </b-col>
          <b-col xl="6" lg="6" md="6" xm="12">
            <div class="box">
              <BarDashboard
                icon="/img/dashboardTop/Component 238 – 11@2x.png"
                iconBig="/img/dashboardTop/connection_icon.png"
                title="Connection"
                subtitle="Engaged and Authentic"
                :feedback="getMessage('Connection')"
                :percentage="promMetrics('Connection')"
                :labels="setCharts('Connection')"
                :verification="getRespondents()"
              />
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import BarDashboard from "@/components/common/BarDashboard";
import CircleRespondents from "@/components/common/CircleRespondents";
import FeedbackScore from "@/components/common/FeedbackScore";
import TMGeneralButton from "@/components/common/TMGeneralButton";
import { mapState } from "vuex";
import { getTmScoreRangeInformationByValue, chartData } from "@/services/utils";

library.add(faEnvelope);

export default {
  name: "DashboardAdminTop",
  data: () => ({
    information: {},
    selected: [],
    groups: null, 
    empty: true,
    selection: [],

  }),
  props: ["dashboardInfo"],
  methods: {
    selectDefault(event, idx) {
      this.selected[idx].checked = event.target.checked;
    },
    selectGroup(event, idx){
      if(!this.selection.includes(idx)){
        this.selection.push(idx);
      }else {
        this.selection = this.selection.filter(element => element !== idx);
      }
    },
    clearSelection() {
      this.selection = [];
    },
    saveSelection(){
      // clean all selections
      this.selected.map(presentation => {
        presentation.checked = false;
        return presentation;
      });

      if(this.selection.length > 0){
        // check selected selections
        this.selection.forEach(group => {
          this.selected[group].checked = true;
        });
      }
    },
    setDisabled(idx){
      return this.selection.length > 5 && !this.selection.includes(idx);
    },
    setChecked(idx){
      return this.selection.includes(idx);
    },
    getRespondents() {
      let respondents = 0;
      var selectedData = this.selected.filter((element) => {
        return element.checked === true;
      });
      selectedData.forEach((element) => {
        respondents += parseInt(element.responses);
      });
      if (respondents) this.empty = false;
      return respondents;
    },
    getNames() {
      var names = this.filterInfo().map((element) => {
        return element.name.replace(" ", "\n ");
      });
      return names;
    },
    getInfo(searchKey) {
      var arrInfo = this.filterInfo().map((element) => {
        var metric = Math.round(element.metrics[searchKey]);
        return {
          value: metric,
          itemStyle: {
            color: getTmScoreRangeInformationByValue(metric).color,
            borderRadius: [50, 50, 0, 0],
          },
          label: {
            show: true,
            position: "top",
          },
        };
      });
      return arrInfo;
    },
    format_date(value) {
      if(!value) return 'No date';
      return new Date(String(value)).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
    },
    getMessage(title) {
      return getTmScoreRangeInformationByValue(this.promMetrics(title)).text;
    },
    setCharts(title) {
      return chartData(
        this.selected.length,
        this.getNames(),
        this.getInfo(title),
        100,
        true
      );
    },
    getMetrics(searchKey) {
      var arrInfo = this.filterInfo().map((element) => {
        var metric = Math.round(element.metrics[searchKey]);
        return metric;
      });
      return arrInfo;
    },
    promMetrics(searchKey) {
      var prom = 0;
      var correctValues = 0;
      this.getMetrics(searchKey).forEach((element) => {
        if (element) {
          prom = prom + element;
          correctValues++;
        }
      });
      return Math.round(prom / correctValues);
    },
    filterInfo() {
      var selectedData = this.selected.filter((element) => {
        return element.checked === true;
      });
      return selectedData;
    },
  },
  computed: {
    ...mapState(["currentUser"]),
  },
  watch: {
    dashboardInfo: function(value){
      let info = value.reduce((acc, current) => {
        return [...acc, ...current.groups];
      }, []);
      var maxInformation = 0;
      var filterInformation = info.filter((element) => {
        return (
          element.metrics["Delivery"] &&
          element.metrics["Connection"] &&
          element.metrics["Content"] &&
          element.metrics["Visuals"]
        );
      });
      var information = filterInformation
        .sort((a, b) => new Date(b.creation_date) - new Date(a.creation_date))
        .map((element, index) => {
          if (maxInformation < 6) {
            maxInformation++;
            this.selection.push(index);
            return {
              ...element,
              checked: true,
            };
          } else {
            return {
              ...element,
              checked: false,
            };
          }
        });
      if (information) {
        this.selected = information.sort(
          (a, b) => b.presentation_date - a.presentation_date
        );
        this.groups = information;
      }
    }
  },
  components: {
    BarDashboard,
    CircleRespondents,
    FeedbackScore,
    TMGeneralButton,
  },
};
</script>
<style lang="less">
@import "../../assets/components/dashboardAdmin/DashboardAdminTop.less";
</style>